import React, { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
    startOnLoad: false,
    theme: 'default',
    securityLevel: 'loose',
    flowchart: {
        useMaxWidth: true,
        htmlLabels: true,
        curve: 'basis',
    },
});

interface MermaidDiagramProps {
    chart: string;
}

const MermaidDiagram: React.FC<MermaidDiagramProps> = ({ chart }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const renderChart = async () => {
            if (!containerRef.current) return;
            try {
                setError(null);
                const id = `mermaid-${Date.now()}`;
                const { svg } = await mermaid.render(id, chart);
                if (containerRef.current) {
                    containerRef.current.innerHTML = svg;
                }
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to render diagram');
            }
        };
        renderChart();
    }, [chart]);

    if (error) {
        return <div style={{ color: 'red', padding: '16px' }}>Diagram error: {error}</div>;
    }

    return <div ref={containerRef} style={{ width: '100%', overflow: 'auto' }} />;
};

export default MermaidDiagram;
